import { Action, createAction, handleActions } from 'redux-actions'

import { STATUS_CODE } from '@/domains/CommonDomain'
import { IRootState } from '@/modules'

export interface Error {
  code: string | number
  message: string
}

export interface IErrorState {
  errorCode: string | number
  errorMessage: string
}

export const ERROR = 'CommonError'

export const SET_ERROR = `${ERROR}/SET_ERROR`
export const RESOLVE_ERROR = `${ERROR}/RESOLVE_ERROR`

export const errorActions = {
  set: createAction<Error>(SET_ERROR),
  resolve: createAction(RESOLVE_ERROR),
}

const initialState = {
  errorCode: '',
  errorMessage: '',
}

export const reducer = {
  [SET_ERROR]: (state: IErrorState, action: Action<Error>) => ({
    ...state,
    errorCode: action.payload.code,
    errorMessage: action.payload.message,
  }),
  [RESOLVE_ERROR]: () => ({
    errorCode: '',
    errorMessage: '',
  }),
}

export const errorSelector = {
  isFullPageError: (state: IRootState) => {
    const { errorCode } = state[ERROR]

    return (
      errorCode === STATUS_CODE.UNINTENDED_EXCEPTION ||
      errorCode === STATUS_CODE.CONNECTION_ERROR ||
      errorCode === STATUS_CODE.UNKNOWN_SERVER_ERROR
    )
  },
  isEnforcedMessagePageError: (state: IRootState) => {
    const { errorCode } = state[ERROR]

    return errorCode === STATUS_CODE.NETWORK_ERROR || errorCode === STATUS_CODE.MAINTENANCE
  },
}

export const errorReducer = handleActions(reducer, initialState)
